<template>
	<transition :name="placement === 'top-center' ? 'canvas-guidance-top' : 'canvas-guidance-bottom'">
		<div v-if="visible" class="canvas-guidance-toast p-3" :class="`canvas-guidance-toast--${placement}`" role="status" aria-live="polite">
			<div class="canvas-guidance-toast__message">{{ message }}</div>
		</div>
	</transition>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "CanvasGuidanceToast",
	extends: BaseComponent,
	props: {visible: Boolean, message: String, placement: {type: String, default: "bottom-center"}},
}
</script>

<style lang="scss">
.canvas-guidance-toast {
	position: fixed;
	left: 50%;
	transform: translateX(-50%);
	width: min(580px, calc(100% - 32px));
	border-radius: 8px;
	background: rgba(28, 36, 52, 0.94);
	box-shadow: 0 8px 24px rgba(16, 24, 40, 0.24);
	color: #fff;
	z-index: 1002;
	pointer-events: none;
	&--bottom-center {bottom: 56px;}
	&--top-center {top: 16px;}
	&__message {font-size: 15px; font-weight: 600; line-height: 1.5; text-align: center; white-space: pre-line;}
	&.canvas-guidance-bottom-enter-active, &.canvas-guidance-bottom-leave-active,
	&.canvas-guidance-top-enter-active, &.canvas-guidance-top-leave-active {transition: opacity 240ms ease-out, transform 240ms ease-out;}
	&.canvas-guidance-bottom-enter-from, &.canvas-guidance-bottom-leave-to {opacity: 0; transform: translateX(-50%) translateY(16px);}
	&.canvas-guidance-top-enter-from, &.canvas-guidance-top-leave-to {opacity: 0; transform: translateX(-50%) translateY(-16px);}
	&.canvas-guidance-bottom-enter-to, &.canvas-guidance-bottom-leave-from,
	&.canvas-guidance-top-enter-to, &.canvas-guidance-top-leave-from {opacity: 1; transform: translateX(-50%) translateY(0);}
}
</style>
